import styled, { css } from 'styled-components';

export const SearchSelector = styled.div`
    position: relative;
    transition: visibility 0.1s linear;
`;

/**
 * Selector Styles
 */
export const Selector = styled.div`
    position: relative;
    display: flex;
    height: 40px;
    border-radius: 40px;
    color: #ffffff;
    line-height: 40px;
    padding: 0 7px;
    transition: background-color 0.1s linear, box-shadow 0.3s linear;

    ${(props) =>
        props.isSelected &&
        css`
            background-color: #00b357;
        `};

    ${(props) =>
        !props.isSelected &&
        css`
            background-color: #ec4652;
        `};

    &:hover {
        box-shadow: 0 0 7px 2px rgba(25, 37, 45, 0.5);
        cursor: pointer;
    }
`;

export const SelectorIcon = styled.div`
    font-size: 24px;
    display: inline-block;
    font-family: sans-serif;
    margin-right: 5px;
`;

export const SelectorSelected = styled.div`
    word-break: break-all;
    font-size: 14px;
    text-transform: uppercase;
    position: relative;
    top: 1px;
    overflow: hidden;
    text-align: left;
    letter-spacing: 1.4px;
`;

export const SelectorDropdownIndicator = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-left: 10px;
    margin-left: auto;
    margin-right: 5px;
    /* width: 60px; */
    text-align: right;
    &,
    > svg {
        font-size: 14px;
    }
`;

export const SelectorDropdownIndicatorReset = styled.div`
    display: inline-block;
    margin-right: 10px;
    opacity: 0.5;
    transition: opacity 0.1s linear;

    &:hover {
        opacity: 1;
    }
`;
